import React, { FunctionComponent } from 'react'

import Scaffold from '../ScaffoldNew'
import { formatBreadCrumb } from '../BasePage/formatBreadCrumb'
import { IBasePageComponent } from './ContainerPageComponent.types'
import { BreadCrumb, Title, Content } from './styles'

const ContainerPage: FunctionComponent<IBasePageComponent> = ({
  breadCrumb,
  showFooterScaffold = true,
  onClickBackButton,
  onClickNextButton,
  onClickExcludeButton,
  titleBackButton,
  titleNextButton,
  isNextButtonDisabled = false,
  iconButtonNext,
  children,
  colorNextButton,
  title,
  titleHeader,
  loading,
  showScaffold = true,
  header,
  tabComponent,
  filter,
}) => {
  return (
    <Content>
      <BreadCrumb>
        <Title>{formatBreadCrumb(breadCrumb)}</Title>
      </BreadCrumb>
      {header && header}
      {tabComponent && tabComponent}
      {filter && filter}
      {showScaffold && (
        <Scaffold
          onClickBackButton={onClickBackButton}
          onClickNextButton={onClickNextButton}
          onClickExcludeButton={onClickExcludeButton}
          titleBackButton={titleBackButton}
          titleNextButton={titleNextButton}
          isNextButtonDisabled={isNextButtonDisabled}
          showFooterScaffold={showFooterScaffold}
          icon={iconButtonNext}
          color={colorNextButton}
          title={title}
          titleHeader={titleHeader}
          loading={loading}
        >
          {children}
        </Scaffold>
      )}
      {!showScaffold && <> {children} </>}
    </Content>
  )
}

export default ContainerPage
